import React from "react";
import ImageSkeleton from "./ImageSkeleton";
import TextSkeleton from "./TextSkeleton";
import CardSkeleton from "./CardSkeleton";

const PageSkeleton = () => (
  <div className="mx-auto w-full max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
    <ImageSkeleton className="h-56 w-full sm:h-72" />
    <div className="mt-8 space-y-4">
      <div className="h-6 w-1/3 animate-pulse rounded bg-stone-300" />
      <TextSkeleton lines={4} />
    </div>
    <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <CardSkeleton count={3} />
    </div>
  </div>
);

export default PageSkeleton;
